<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <title>Transactions | County Revenue System</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Revenue management system" name="description" />
      <meta content="County Revenue System" name="author" />
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.png">
      <!-- droping file -->
      <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Bootstrap select styling -->
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <NavigationBar/>
    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <div>
                  <h4 class="mb-sm-0 font-size-18">Transaction Management</h4>
                  <p class="text-muted mb-0">Monitor and analyze all payment transactions</p>
                </div>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);" @click="gotTo('dashboard')">Dashboard</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);" @click="gotTo('receipts')">Receipts</a></li>
                    <li class="breadcrumb-item active">Transactions</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Total Transactions</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{numberFormat(summary.count || 0)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-primary">
                        <span class="avatar-title rounded-circle bg-primary">
                          <i class="bx bx-receipt font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Total Amount</span>
                      <h4 class="mb-3">
                        <span class="counter-value text-success">{{formatPrice(summary.total || 0)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-success">
                        <span class="avatar-title rounded-circle bg-success">
                          <i class="bx bx-money font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Average Transaction</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{getAverageTransaction()}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-info">
                        <span class="avatar-title rounded-circle bg-info">
                          <i class="bx bx-trending-up font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Payment Methods</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{getPaymentMethodCount()}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-warning">
                        <span class="avatar-title rounded-circle bg-warning">
                          <i class="bx bx-credit-card font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Content -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white border-bottom">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <h5 class="card-title mb-0">Transaction History</h5>
                      <small class="text-muted">Showing {{transactions.length}} of {{numberFormat(summary.count || 0)}} transactions</small>
                    </div>
                    <div class="col-md-6">
                      <div class="d-flex justify-content-end gap-2">
                        <button @click="refreshData()" type="button" class="btn btn-outline-primary btn-sm" :disabled="loading">
                          <i class="bx bx-refresh" :class="{'bx-spin': loading}"></i>
                          {{ loading ? 'Refreshing...' : 'Refresh' }}
                        </button>

                        <!-- Download Buttons Group -->
                        <div class="btn-group" role="group">
                          <!-- Download Current Page -->
                          <button
                              v-if="getRight('DOWNLOAD ALL PAYMENT REPORTS')"
                              @click="downloadCurrentPage()"
                              type="button"
                              class="btn btn-success btn-sm"
                              :disabled="transactions.length === 0">
                            <i class="bx bx-download"></i>
                            Current ({{ transactions.length }})
                          </button>

                          <!-- Download All Records -->
                          <button
                              v-if="getRight('DOWNLOAD ALL PAYMENT REPORTS')"
                              @click="downloadAllTransactions()"
                              type="button"
                              class="btn btn-primary btn-sm"
                              :disabled="isDownloadingAll || summary.count === 0">
                            <span v-if="isDownloadingAll">
                              <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                              Downloading...
                            </span>
                            <span v-else>
                              <i class="bx bxs-cloud-download"></i>
                              All ({{ numberFormat(summary.count) }})
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Filters Row -->
                  <div class="row mt-3 g-3">
                    <div class="col-md-3">
                      <label class="form-label">Search Transactions</label>
                      <div class="search-box">
                        <div class="position-relative">
                          <input v-model="searchValue" class="form-control" placeholder="Search transactions..." type="text">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Payment Method</label>
                      <select class="form-select" v-model="paymentMode">
                        <option value="">All Payments</option>
                        <option value="MPESA">M-PESA</option>
                        <option value="BANK">Bank Transfer</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Date From</label>
                      <input v-model="dateFrom" class="form-control" type="date">
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Date To</label>
                      <input v-model="dateTo" class="form-control" type="date">
                    </div>
                    <div class="col-md-3">
                      <label class="form-label">Quick Filters</label>
                      <div class="d-flex gap-1">
                        <button @click="setDateRange('today')" type="button" class="btn btn-outline-primary btn-sm">Today</button>
                        <button @click="setDateRange('week')" type="button" class="btn btn-outline-primary btn-sm">Week</button>
                        <button @click="setDateRange('month')" type="button" class="btn btn-outline-primary btn-sm">Month</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body p-0">
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary mb-3" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <h5>Loading Transactions...</h5>
                    <p class="text-muted">Please wait while we fetch the latest transaction data.</p>
                  </div>

                  <div v-else-if="transactions.length === 0" class="text-center py-5">
                    <div class="py-4">
                      <i class="bx bx-receipt font-size-96 text-muted"></i>
                      <h4 class="mt-3">No Transactions Found</h4>
                      <p class="text-muted">No transactions found for the selected criteria. Try adjusting your filters.</p>
                      <button @click="clearFilters()" class="btn btn-outline-primary">Clear Filters</button>
                    </div>
                  </div>

                  <div v-else class="table-responsive">
                    <table class="table table-hover align-middle mb-0">
                      <thead class="table-dark">
                      <tr>
                        <th style="width: 120px;">Payment Type</th>
                        <th style="width: 150px;">Account Name</th>
                        <th style="width: 120px;">Account From</th>
                        <th>Description</th>
                        <th style="width: 150px;">Transaction Code</th>
                        <th class="text-end" style="width: 120px;">Amount</th>
                        <th style="width: 120px;">Reference</th>
                        <th style="width: 120px;">Date</th>
                        <th style="width: 150px;">Customer</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in transactions" :key="item.id">
                        <td>
                          <div class="d-flex align-items-center">
                            <span class="badge bg-light text-dark me-2">{{getItemNumber(index)}}</span>
                            <span class="badge" :class="getPaymentMethodClass(item.payment_type)">
                              {{item.payment_type}}
                            </span>
                          </div>
                        </td>
                        <td>
                          <span class="fw-medium">{{item.accountName || 'N/A'}}</span>
                        </td>
                        <td>
                          <span class="text-nowrap">{{maskPhoneNumber(item.account_from)}}</span>
                        </td>
                        <td>
                          <span class="text-truncate" style="max-width: 200px;" :title="item.transaction_desc">
                            {{item.transaction_desc || '-'}}
                          </span>
                        </td>
                        <td>
                          <code class="text-primary">{{item.transaction_code}}</code>
                        </td>
                        <td class="text-end">
                          <div class="d-flex flex-column align-items-end">
                            <strong class="text-success">{{formatPrice(item.amount)}}</strong>
                            <small class="text-muted">{{getTransactionPercentage(item.amount)}}%</small>
                          </div>
                        </td>
                        <td>
                          <span class="text-nowrap">{{item.account_ref || '-'}}</span>
                        </td>
                        <td>
                          <span class="text-nowrap">{{formatDate(item.date)}}</span>
                        </td>
                        <td>
                          <strong class="text-nowrap">{{maskName(item.names)}}</strong>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="card-footer bg-light" v-if="transactions.length > 0">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <div class="d-flex align-items-center gap-2">
                        <span class="text-muted">Show</span>
                        <select class="form-select form-select-sm" v-model="pageSize" style="width: auto;">
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="500">500</option>
                          <option value="1000">1000</option>
                        </select>
                        <span class="text-muted">entries</span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <nav aria-label="Page navigation">
                        <ul class="pagination pagination-sm justify-content-end mb-0">
                          <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <a class="page-link" @click="prevPage" :disabled="currentPage === 1">
                              <i class="bx bx-chevron-left"></i>
                            </a>
                          </li>
                          <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page"
                              class="page-item" :class="{ active: currentPage === page }">
                            <span v-if="page === '...'" class="page-link">{{ page }}</span>
                            <a v-else class="page-link" @click="goToPage(page)">{{ page }}</a>
                          </li>
                          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <a class="page-link" @click="nextPage" :disabled="currentPage === totalPages">
                              <i class="bx bx-chevron-right"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>

                  <!-- Summary Row -->
                  <div class="row mt-3 pt-3 border-top">
                    <div class="col-12">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <strong>{{numberFormat(summary.count || 0)}} Total Transactions</strong>
                        </div>
                        <div class="text-end">
                          <div class="text-success"><strong>{{formatPrice(summary.total || 0)}}</strong></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Transaction Analysis -->
                  <div v-if="transactions.length > 0" class="mt-4 pt-3 border-top bg-light">
                    <div class="row">
                      <div class="col-md-6">
                        <h6 class="mb-3 text-primary">
                          <i class="bx bx-chart-pie me-2"></i>
                          Payment Method Distribution
                        </h6>
                        <div v-for="method in getPaymentMethodStats()" :key="method.name" class="mb-2">
                          <div class="d-flex justify-content-between align-items-center mb-1">
                            <span class="fw-medium">{{ method.name }}</span>
                            <span class="text-success">{{ method.count }} ({{ method.percentage }}%)</span>
                          </div>
                          <div class="progress" style="height: 8px;">
                            <div class="progress-bar" :class="method.colorClass"
                                 :style="`width: ${method.percentage}%`">
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <h6 class="mb-3 text-info">
                          <i class="bx bx-trending-up me-2"></i>
                          Transaction Insights
                        </h6>
                        <ul class="list-unstyled">
                          <li class="mb-2">
                            <i class="bx bx-money text-success me-2"></i>
                            Highest transaction: <strong>{{ getHighestTransaction() }}</strong>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-chart-line text-primary me-2"></i>
                            Average per transaction: <strong>{{ getAverageTransaction() }}</strong>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-time text-warning me-2"></i>
                            Date range: <strong>{{ getDateRange() }}</strong>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-trending-up text-info me-2"></i>
                            Daily average: <strong>{{ getDailyAverage() }}</strong>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Download Progress Modal with Pause/Resume and Time Estimation -->
      <div class="modal fade" id="downloadProgressModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title text-white">
                <i class="bx bxs-download me-2"></i>Downloading All Transactions
              </h5>
            </div>
            <div class="modal-body">
              <div class="text-center mb-3">
                <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" role="status" v-if="!downloadPaused">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <div v-else class="mb-3">
                  <i class="bx bx-pause-circle text-warning" style="font-size: 3rem;"></i>
                </div>
                <h5 v-if="!downloadPaused">Please wait while we download your records...</h5>
                <h5 v-else class="text-warning">Download Paused</h5>

                <!-- Estimated Time Remaining -->
                <div v-if="downloadProgress.estimatedTimeRemaining && !downloadPaused" class="mt-2">
                  <p class="text-muted mb-1">
                    <i class="bx bx-time-five me-1"></i>
                    <strong>{{ formatTimeRemaining(downloadProgress.estimatedTimeRemaining) }}</strong> remaining
                  </p>
                  <small class="text-muted">
                    Average speed: {{ downloadProgress.averageSpeed }} records/sec
                  </small>
                </div>

                <p class="text-muted mt-2">{{ downloadPaused ? 'You can resume or cancel the download.' : 'This may take several minutes depending on the amount of data.' }}</p>
              </div>

              <div class="progress mb-3" style="height: 25px;">
                <div
                    class="progress-bar progress-bar-striped"
                    :class="{'progress-bar-animated': !downloadPaused, 'bg-warning': downloadPaused}"
                    role="progressbar"
                    :style="{ width: downloadProgress.percentage + '%' }"
                    :aria-valuenow="downloadProgress.percentage"
                    aria-valuemin="0"
                    aria-valuemax="100">
                  {{ downloadProgress.percentage }}%
                </div>
              </div>

              <div class="d-flex justify-content-between text-muted small mb-3">
                <span>Page {{ downloadProgress.current }} of {{ downloadProgress.total }}</span>
                <span>{{ downloadProgress.records }} / {{ numberFormat(downloadProgress.totalRecords) }} records</span>
              </div>

              <!-- Error Display -->
              <div v-if="downloadError" class="alert alert-danger d-flex align-items-center" role="alert">
                <i class="bx bx-error-circle me-2"></i>
                <div class="flex-grow-1">
                  <strong>Error:</strong> {{ downloadError }}
                  <br>
                  <small>You can retry from where it stopped or cancel the download.</small>
                </div>
              </div>

              <!-- Retry Count Display -->
              <div v-if="downloadRetryCount > 0" class="alert alert-warning d-flex align-items-center mb-3" role="alert">
                <i class="bx bx-info-circle me-2"></i>
                <small>Retry attempt {{ downloadRetryCount }} of 3</small>
              </div>

              <!-- Action Buttons -->
              <div class="d-flex gap-2 justify-content-center mb-3">
                <button
                    v-if="!downloadPaused && !downloadError"
                    @click="pauseDownload"
                    class="btn btn-warning btn-sm">
                  <i class="bx bx-pause me-1"></i>Pause
                </button>
                <button
                    v-if="downloadPaused || downloadError"
                    @click="resumeDownload"
                    class="btn btn-success btn-sm">
                  <i class="bx bx-play me-1"></i>Resume
                </button>
                <button
                    @click="cancelDownload"
                    class="btn btn-danger btn-sm">
                  <i class="bx bx-x me-1"></i>Cancel
                </button>
              </div>

              <div class="alert alert-info d-flex align-items-center" role="alert">
                <i class="bx bx-info-circle me-2"></i>
                <small>{{ downloadPaused ? 'Download is paused. Your progress has been saved.' : 'Please do not close this window or navigate away.' }}</small>
              </div>

              <!-- Download Statistics -->
              <div v-if="downloadProgress.records > 0" class="mt-3 pt-3 border-top">
                <div class="row text-center">
                  <div class="col-4">
                    <small class="text-muted d-block">Downloaded</small>
                    <strong>{{ numberFormat(downloadProgress.records) }}</strong>
                  </div>
                  <div class="col-4">
                    <small class="text-muted d-block">Remaining</small>
                    <strong>{{ numberFormat(downloadProgress.totalRecords - downloadProgress.records) }}</strong>
                  </div>
                  <div class="col-4">
                    <small class="text-muted d-block">Success Rate</small>
                    <strong>{{ getSuccessRate() }}%</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Receipt Details Modal -->
      <div id="receiptDetail" class="modal fade receipting-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Receipt Details</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-6">
                  <address>
                    <strong class="text-capitalize">Received from:</strong><br>
                    {{receiptDetail.paidBy}}<br>
                  </address>
                </div>
                <div class="col-sm-6 text-sm-end">
                  <address class="mt-2 mt-sm-0">
                    <strong>Payment Method</strong><br>
                    <span class="fw-medium">{{receiptDetail.source}}</span><br>
                    On {{receiptDetail.dateCreated}}
                  </address>
                </div>
              </div>
              <div class="col-12">
                <div class="py-2 mt-3">
                  <h3 class="font-size-15 fw-bold">{{receiptDetail.receiptNo}}</h3>
                </div>
              </div>
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table table-nowrap vertical-align-middle">
                    <thead class="bg-light">
                    <tr>
                      <th style="width: 70px;">No.</th>
                      <th>Description</th>
                      <th class="text-end">Amount</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in receiptInfos" :value="item" :key="index" title="">
                      <td>{{index+1}}</td>
                      <td>
                        <p class="the-bill-item mb-0 p-0 m-0">{{item.description}}</p>
                      </td>
                      <td class="text-end">{{formatPrice(item.receiptAmount)}}</td>
                    </tr>
                    </tbody>
                    <tfoot class="bg-light">
                    <tr>
                      <td colspan="2" class="border-0 text-end text-right">
                        <strong>Total</strong>
                      </td>
                      <td class="border-0 text-end">
                        <h5 class="m-0 text-uppercase fw-bold">{{formatPrice(receiptDetail.receiptAmount)}}</h5>
                      </td>
                    </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <a @click="printReceipt()" type="button" target="_blank" class="btn btn-primary waves-effect waves-light">
                <i class="mdi mdi-printer font-size-16 align-middle me-2"></i> Print receipt
              </a>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">©County Revenue System</div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Developed by County IT Department
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import {paysol, biller, execute, execute2, executeDownload, getRight} from "@/api";
import moment from 'moment';

export default {
  name: "Transactions",
  components: {NavigationBar},

  data() {
    return{
      loading: false,
      downloading: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      summary: {
        count: 0,
        total: 0
      },

      totalAmount: null,

      paymentMode:'',
      download:'Download Report',
      dateFrom:'',
      dateTo:'',
      searchValue:"",
      customers:[ {
        account_from: "",
        count: "",
        names: ""
      }],
      transactions:[],

      monthNames: ['','January','February','March','April','May','June','July','August','September','October','November','December'],
      monthName:'',
      month:'',
      receiptNo:'',
      receiptDetail:{
        id: "151",
        receiptNo: "BLL2023041621063411",
        billNo: "BLL0416090620",
        detailAmount: "20",
        receiptAmount: "20",
        billBalance: "0",
        costCenterNo: "",
        accountNo: ",",
        incomeTypeDescription: "Market Fees,",
        feeID: "274,",
        wardID: "472761372",
        subCountyID: "47276",
        currency: "KES",
        source: "",
        transactionCode: "BLL0416090620",
        paidBy: "#",
        dateCreated: "2023-04-16 09:06:34",
        dateModified: "2023-04-16 09:06:34",
        createdBy: "1",
        modifiedBy: "#",
        isActive: "1",
        statu: "PAID"
      },
      receiptDetails:[],
      receiptInfos:[],

      // Download All functionality with pause/resume and time estimation
      isDownloadingAll: false,
      downloadPaused: false,
      downloadCancelled: false,
      downloadError: null,
      downloadRetryCount: 0,
      maxRetries: 3,
      downloadProgress: {
        current: 0,
        total: 0,
        percentage: 0,
        records: 0,
        totalRecords: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0
      },
      allTransactionsData: [],
      downloadState: {
        startPage: 1,
        currentPage: 0,
        batchSize: 1000,
        totalPages: 0,
        accumulatedData: []
      }
    }
  },
  watch: {
    pageSize(newPageSize) {
      this.getTransactions("")
      const totalItems = this.summary.count;
      const newTotalPages = Math.ceil(totalItems / newPageSize);
      this.totalPages = newTotalPages;
      this.currentPage = 1;
    },
  },
  computed:{
    totalReceiptAmount() {
      return this.formatPrice(this.receiptDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.receiptAmount), 0));
    }
  },
  mounted() {
    this.dateFrom = moment().format('YYYY-MM-DD')
    this.dateTo = moment().format('YYYY-MM-DD')
    this.getTransactions()

    this.$watch('searchValue', function(newValue) {
      this.currentPage = 1;
      this.getTransactions(newValue)
    })
    this.$watch('dateFrom', function(newValue) {
      if(this.dateFrom==='' || this.dateTo===''){
        return;
      }else{
        this.currentPage = 1;
        this.getTransactions(newValue)
      }
    })
    this.$watch('dateTo', function(newValue) {
      if(this.dateFrom==='' || this.dateTo===''){
        return;
      }else{
        this.currentPage = 1;
        this.getTransactions(newValue)
      }
    })

    this.$watch('paymentMode', function() {
      this.currentPage = 1;
      this.getTransactions()
    })

    const d = new Date();
    this.month = d.getMonth();
    this.monthName = this.getCurrentMonth()+" "+ this.getCurrentYear()

    this.menuAccess()
  },

  methods: {
    // Helper methods for better UX
    getItemNumber(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },

    getAverageTransaction() {
      if (this.summary.count === 0 || !this.summary.total) return this.formatPrice(0);
      return this.formatPrice(Math.round(this.summary.total / this.summary.count));
    },

    getPaymentMethodCount() {
      const methods = new Set(this.transactions.map(t => t.payment_type));
      return methods.size;
    },

    getTransactionPercentage(amount) {
      if (!this.summary.total || this.summary.total === 0) return '0.0';
      return ((Number(amount) / this.summary.total) * 100).toFixed(1);
    },

    getPaymentMethodClass(method) {
      const classes = {
        'MPESA': 'bg-success',
        'BANK': 'bg-info',
      };
      return classes[method?.toUpperCase()] || 'bg-secondary';
    },

    getPaymentMethodStats() {
      const methods = {};
      this.transactions.forEach(item => {
        const method = item.payment_type || 'UNKNOWN';
        methods[method] = (methods[method] || 0) + 1;
      });

      const total = this.transactions.length;
      const colors = ['bg-success', 'bg-info', 'bg-warning', 'bg-secondary', 'bg-primary'];

      return Object.entries(methods).map(([name, count], index) => ({
        name,
        count,
        percentage: total > 0 ? ((count / total) * 100).toFixed(1) : 0,
        colorClass: colors[index % colors.length]
      })).sort((a, b) => b.count - a.count);
    },

    getHighestTransaction() {
      if (this.transactions.length === 0) return this.formatPrice(0);
      const highest = Math.max(...this.transactions.map(item => Number(item.amount)));
      return this.formatPrice(highest);
    },

    getDateRange() {
      if (!this.dateFrom || !this.dateTo) return 'Not specified';
      const days = moment(this.dateTo).diff(moment(this.dateFrom), 'days') + 1;
      return `${days} day${days !== 1 ? 's' : ''}`;
    },

    getDailyAverage() {
      if (!this.dateFrom || !this.dateTo || !this.summary.total) return this.formatPrice(0);
      const days = moment(this.dateTo).diff(moment(this.dateFrom), 'days') + 1;
      return this.formatPrice(Math.round(this.summary.total / days));
    },

    refreshData() {
      this.getTransactions();
    },

    clearFilters() {
      this.searchValue = '';
      this.paymentMode = '';
      this.dateFrom = moment().format('YYYY-MM-DD');
      this.dateTo = moment().format('YYYY-MM-DD');
      this.currentPage = 1;
    },

    setDateRange(preset) {
      const today = moment();

      switch(preset) {
        case 'today':
          this.dateFrom = today.format('YYYY-MM-DD');
          this.dateTo = today.format('YYYY-MM-DD');
          break;
        case 'week':
          this.dateFrom = today.startOf('week').format('YYYY-MM-DD');
          this.dateTo = today.endOf('week').format('YYYY-MM-DD');
          break;
        case 'month':
          this.dateFrom = today.startOf('month').format('YYYY-MM-DD');
          this.dateTo = today.endOf('month').format('YYYY-MM-DD');
          break;
      }
    },

    formatDate(date) {
      return moment(date).format('MMM DD, YYYY');
    },

    // Format time remaining in human-readable format
    formatTimeRemaining(seconds) {
      if (!seconds || seconds <= 0) return 'Calculating...';

      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);

      if (hours > 0) {
        return `${hours}h ${minutes}m ${secs}s`;
      } else if (minutes > 0) {
        return `${minutes}m ${secs}s`;
      } else {
        return `${secs}s`;
      }
    },

    // Calculate estimated time remaining
    calculateEstimatedTime() {
      if (!this.downloadProgress.startTime || this.downloadProgress.current === 0) {
        return;
      }

      const elapsedTime = (Date.now() - this.downloadProgress.startTime) / 1000;
      const recordsDownloaded = this.downloadProgress.records;
      const remainingRecords = this.downloadProgress.totalRecords - recordsDownloaded;

      if (recordsDownloaded > 0 && elapsedTime > 0) {
        const averageSpeed = recordsDownloaded / elapsedTime;
        this.downloadProgress.averageSpeed = averageSpeed.toFixed(2);

        const estimatedTimeRemaining = remainingRecords / averageSpeed;
        this.downloadProgress.estimatedTimeRemaining = estimatedTimeRemaining;
      }
    },

    // Get Success Rate
    getSuccessRate() {
      if (this.downloadProgress.total === 0) return 100;
      const successfulPages = this.downloadProgress.current - this.downloadRetryCount;
      return Math.round((successfulPages / this.downloadProgress.total) * 100);
    },

    // Pause Download
    pauseDownload() {
      this.downloadPaused = true;
      console.log('Download paused at page:', this.downloadState.currentPage);
    },

    // Resume Download
    async resumeDownload() {
      this.downloadPaused = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;

      console.log('Resuming download from page:', this.downloadState.currentPage + 1);

      await this.continueDownload();
    },

    // Cancel Download
    cancelDownload() {
      const confirmed = confirm('Are you sure you want to cancel the download? All progress will be lost.');

      if (confirmed) {
        this.downloadCancelled = true;
        this.closeDownloadModal();
      }
    },

    // Close Download Modal
    closeDownloadModal() {
      const modalElement = document.getElementById('downloadProgressModal');
      if (modalElement) {
        const existingModal = bootstrap.Modal.getInstance(modalElement);
        if (existingModal) {
          existingModal.hide();
        }
      }

      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      // Reset state
      this.isDownloadingAll = false;
      this.downloadPaused = false;
      this.downloadCancelled = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      this.allTransactionsData = [];
      this.downloadProgress = {
        current: 0,
        total: 0,
        percentage: 0,
        records: 0,
        totalRecords: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0
      };
      this.downloadState = {
        startPage: 1,
        currentPage: 0,
        batchSize: 1000,
        totalPages: 0,
        accumulatedData: []
      };
    },

    // Download Current Page (Client-side CSV generation)
    downloadCurrentPage() {
      if (this.transactions.length === 0) {
        alert('No data available to download');
        return;
      }

      try {
        // Generate CSV from current page data
        const csv = this.generateTransactionsCSV(this.transactions);

        // Create blob and download
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', `Transactions_Page_${this.currentPage}_${moment().format('YYYY-MM-DD_HHmmss')}.csv`);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        alert(`Successfully downloaded ${this.transactions.length} transactions from current page`);
      } catch (error) {
        console.error('Download error:', error);
        alert('Failed to download data: ' + error.message);
      }
    },

    // Download All Transactions with Pause/Resume/Retry and Time Estimation
    async downloadAllTransactions() {
      // Validate date range
      if (!this.dateFrom || !this.dateTo) {
        alert('Please select date range before downloading');
        return;
      }

      // Confirm action
      const isConfirmed = confirm(
          `You are about to download all ${this.numberFormat(this.summary.count)} transactions from ${this.dateFrom} to ${this.dateTo}. This may take several minutes. Do you want to continue?`
      );

      if (!isConfirmed) return;

      this.isDownloadingAll = true;
      this.downloadPaused = false;
      this.downloadCancelled = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      this.allTransactionsData = [];

      const batchSize = 1000;
      const totalRecords = this.summary.count;
      const totalPages = Math.ceil(totalRecords / batchSize);

      this.downloadState = {
        startPage: 1,
        currentPage: 0,
        batchSize: batchSize,
        totalPages: totalPages,
        accumulatedData: []
      };

      this.downloadProgress = {
        current: 0,
        total: totalPages,
        percentage: 0,
        records: 0,
        totalRecords: totalRecords,
        startTime: Date.now(),
        estimatedTimeRemaining: null,
        averageSpeed: 0
      };

      const modalElement = document.getElementById('downloadProgressModal');
      const progressModal = new bootstrap.Modal(modalElement);
      progressModal.show();

      await this.continueDownload();
    },

    // Continue Download (used by both initial download and resume)
    async continueDownload() {
      try {
        const startPage = this.downloadState.currentPage + 1;
        const totalPages = this.downloadState.totalPages;

        for (let page = startPage; page <= totalPages; page++) {
          if (this.downloadPaused) {
            console.log('Download paused, waiting for resume...');
            return;
          }

          if (this.downloadCancelled) {
            console.log('Download cancelled by user');
            return;
          }

          try {
            this.downloadState.currentPage = page;
            this.downloadProgress.current = page;
            this.downloadProgress.percentage = Math.round((page / totalPages) * 100);

            const pageData = await this.fetchTransactionsPageWithRetry(page, this.downloadState.batchSize);

            if (pageData && pageData.length > 0) {
              this.downloadState.accumulatedData = [...this.downloadState.accumulatedData, ...pageData];
              this.allTransactionsData = this.downloadState.accumulatedData;
              this.downloadProgress.records = this.allTransactionsData.length;

              this.calculateEstimatedTime();
            }

            this.downloadRetryCount = 0;
            this.downloadError = null;

            await this.delay(50);

          } catch (error) {
            console.error(`Error fetching page ${page}:`, error);
            this.downloadError = error.message;
            this.downloadPaused = true;
            return;
          }
        }

        await this.finalizeDownload();

      } catch (error) {
        console.error('Download error:', error);
        this.downloadError = error.message;
        this.downloadPaused = true;
      }
    },

    // Fetch Transactions Page with Retry Logic
    async fetchTransactionsPageWithRetry(page, rowsPerPage, retryCount = 0) {
      try {
        const data = new FormData();
        data.append("function", "getTransactionsPagination");
        data.append("keyword", this.searchValue);
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("page", page);
        data.append("rows_per_page", rowsPerPage);
        data.append("paymentMode", this.paymentMode);

        const res = await execute2(data, biller);

        if (res.data.success) {
          return res.data.data.Transactions || [];
        } else {
          throw new Error(res.data.message || 'Failed to fetch page data');
        }
      } catch (error) {
        if (retryCount < this.maxRetries) {
          this.downloadRetryCount = retryCount + 1;
          console.log(`Retry ${this.downloadRetryCount} for page ${page}`);

          const waitTime = Math.pow(2, retryCount) * 1000;
          await this.delay(waitTime);

          return this.fetchTransactionsPageWithRetry(page, rowsPerPage, retryCount + 1);
        } else {
          throw new Error(`Failed after ${this.maxRetries} retries: ${error.message}`);
        }
      }
    },

    // Finalize Download
    async finalizeDownload() {
      if (this.allTransactionsData.length > 0) {
        const csv = this.generateTransactionsCSV(this.allTransactionsData);

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        const fileName = `All_Transactions_${this.dateFrom}_to_${this.dateTo}_${moment().format('YYYY-MM-DD_HHmmss')}.csv`;

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        await this.delay(500);

        alert(`Successfully downloaded ${this.allTransactionsData.length} transactions!`);

        this.closeDownloadModal();
      } else {
        alert('No transactions found to download');
        this.closeDownloadModal();
      }
    },

    // Delay helper function
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    // Generate CSV from transactions data
// Generate CSV from transactions data
    generateTransactionsCSV(data) {
      if (!data || data.length === 0) return '';

      // Define CSV headers - REMOVED "Verified" and "Verified By"
      const headers = [
        'NO.',
        'Payment Type',
        'Account Name',
        'Account From',
        'Description',
        'Transaction Code',
        'Amount',
        'Reference',
        'Date',
        'Customer'
      ];

      // Create CSV content
      let csv = headers.join(',') + '\n';

      // Add data rows
      data.forEach((item, index) => {
        const row = [
          index + 1,
          this.escapeCSV(item.payment_type),
          this.escapeCSV(item.accountName),
          this.escapeCSV(item.account_from),
          this.escapeCSV(item.transaction_desc),
          this.escapeCSV(item.transaction_code),
          item.amount || 0,
          this.escapeCSV(item.account_ref),
          this.escapeCSV(item.date),
          this.escapeCSV(item.names)
        ];
        csv += row.join(',') + '\n';
      });

      return csv;
    },

    // Escape CSV values
    escapeCSV(value) {
      if (value === null || value === undefined) return '';
      const stringValue = String(value);
      // Escape quotes and wrap in quotes if contains comma, quote, or newline
      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return '"' + stringValue.replace(/"/g, '""') + '"';
      }
      return stringValue;
    },

    //pagination code
    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
      }
      if (end < totalPages) {
        pages.push("...");
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getTransactions("")
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getTransactions("")
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getTransactions("")
      }
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') {
        return input;
      }

      const digits = input.replace(/\D/g, '');

      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }

      return input;
    },

    menuAccess(){
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Transactions");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then(() => {
            // Success
          })
          .catch(() => {
            console.error("Menu access error");
          });
    },

    getRight(type){
      return getRight(type)
    },

    maskName(name) {
      if (!name) return '';

      const nameParts = name.split(' ');
      const maskedParts = nameParts.map((part) => {
        return part.length > 2
            ? part[0] + '*'.repeat(part.length - 2) + part[part.length - 1]
            : part;
      });

      return maskedParts.join(' ');
    },

    getTransactions(){
      this.transactions.splice(0)
      this.loading = true

      const data = new FormData();
      data.append("function", "getTransactionsPagination");
      data.append("keyword", this.searchValue);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("paymentMode",this.paymentMode)

      execute2(data,biller)
          .then((res) =>{
            this.loading = false

            if (res.data.success) {
              this.summary.count = 0
              this.summary.total = 0
              this.totalAmount = null

              this.transactions = res.data.data.Transactions || []
              this.summary = res.data.data.summary || { count: 0, total: 0 }
              this.totalPages = Math.ceil(this.summary.count / this.pageSize);

              this.totalAmount = this.summary.total

            } else {
              console.log("API returned success: false", res.data.message);
              alert(res.data.message)
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error("API Error:", e);
            this.message = e.message
            alert("Failed to load transactions. Please check your connection and try again.");
          });
    },

    getCurrentMonth(){
      const d = new Date();
      const monthName = this.monthNames[d.getMonth()];
      return monthName;
    },

    getCurrentYear(){
      const date = new Date();
      const currentYear = date.getFullYear();
      return currentYear;
    },

    formatPrice(value) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num || 0)
    },

    gotTo(route){
      router.push(route)
    },

    printReceipt() {
      // Receipt printing logic
      window.print();
    }
  }
}
</script>

<style scoped>
.card-h-100 {
  height: 100%;
}

.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #74788d;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
  font-weight: 600;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.bx-spin {
  animation: spin 1s linear infinite;
}

.page-link {
  cursor: pointer;
}

.page-item.disabled .page-link {
  cursor: not-allowed;
}

.progress {
  background-color: #f3f3f3;
}

.badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Download button group styling */
.btn-group .btn {
  white-space: nowrap;
}

.btn-group .btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* Progress modal styling */
#downloadProgressModal .modal-body {
  padding: 2rem;
}

#downloadProgressModal .progress {
  background-color: #e9ecef;
}

#downloadProgressModal .progress-bar {
  font-weight: 600;
  font-size: 0.875rem;
}

/* Pause icon animation */
.bx-pause-circle {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Time remaining display */
.text-muted strong {
  color: #495057;
  font-weight: 600;
}

/* Ensure modal backdrop is properly removed */
body.modal-open {
  overflow: hidden;
}
</style>